/**
 * Enums for puzzle status and attempt results.
 * Shared between API and client for type safety.
 */
/** Status of a player's progress on a daily puzzle */
export var Status;
(function (Status) {
    Status["InProgress"] = "in_progress";
    Status["Solved"] = "solved";
    Status["Missed"] = "missed";
    Status["Revealed"] = "revealed";
})(Status || (Status = {}));
/** Result of a single move attempt */
export var AttemptResult;
(function (AttemptResult) {
    /** Move was not legal in the position */
    AttemptResult["Illegal"] = "illegal";
    /** Move was legal but not the puzzle solution */
    AttemptResult["Incorrect"] = "incorrect";
    /** Move was correct, advance to next step */
    AttemptResult["Correct"] = "correct";
    /** Move was correct and completed the puzzle */
    AttemptResult["Solved"] = "solved";
    /** Move was incorrect and exhausted all attempts */
    AttemptResult["Missed"] = "missed";
})(AttemptResult || (AttemptResult = {}));
/** Day label for display */
export var DayLabel;
(function (DayLabel) {
    DayLabel["Today"] = "TODAY";
    DayLabel["Yesterday"] = "YESTERDAY";
})(DayLabel || (DayLabel = {}));
//# sourceMappingURL=enums.js.map